import {
  EditorState,
  SelectionState,
  Modifier,
  AtomicBlockUtils,
  convertFromRaw,
} from 'draft-js'
import { createHeader, createFooter } from '../message-templates/color-block'

const blockCreationFns = {
  header: createHeader,
  footer: createFooter,
}

export function insertColorBlock(editorState, text, styles) {
  const contentState = editorState.getCurrentContent()
  const contentStateWithEntity = contentState.createEntity(
    'colorblock',
    'MUTABLE',
    { styles },
  )

  const entityKey = contentStateWithEntity.getLastCreatedEntityKey()
  const newEditorState = AtomicBlockUtils.insertAtomicBlock(
    editorState,
    entityKey,
    text,
  )

  return EditorState.forceSelection(
    newEditorState,
    editorState.getCurrentContent().getSelectionAfter(),
  )
}

export function injectColorBlockFromNamedTemplate(colorBlockType, contentState, selection) {
  const rawState = blockCreationFns[colorBlockType]()
  const colorBlockContentState = convertFromRaw(rawState)

  return Modifier.replaceWithFragment(
    contentState,
    selection,
    colorBlockContentState.getBlockMap(),
  )
}

export function replaceBlockText(text, contentState, contentBlock) {
  const blockKey = contentBlock.getKey()
  const entityKey = contentBlock.getEntityAt(0)
  const selection = new SelectionState({
    anchorKey: blockKey,
    anchorOffset: 0,
    focusKey: blockKey,
    focusOffset: contentBlock.getLength(),
  })

  return Modifier.replaceText(
    contentState,
    selection,
    text,
    null,
    entityKey,
  )
}



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/ColorBlock/modifiers.js